import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tooltip', 'open', 'Atidaryti paaiškinimo langą');
Labels.set('ui-tooltip', 'close', 'Uždaryti paaiškinimo langą');
